import React, { useState, useEffect } from 'react';
import { Input, Tabs, Button, Modal, Form, Select, Menu as AntMenu, Grid, Table } from 'antd';
import { EyeOutlined, ScheduleOutlined, StopOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'antd';
import Menu from '../../components/Menu/Menu';
import './Lists.scss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MobileBottomMenu from '../../components/MobileBottomMenu/MobileBottomMenu';
import MobileMenu from "../../components/Menu/MobileMenu";
import Header from '../../components/Header/Header';
import { listService } from "../../services/ListService";
import { useLocation } from 'react-router-dom';
import Countdown from "./Countdown";
import moment from 'moment'
import ListStatusGuard from './ListStatusGuard';
const { Search } = Input;
const { TabPane } = Tabs;
const { Option } = Select;
const VerticalDotsIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="currentColor"
        style={{ cursor: 'pointer' }}
    >
        <circle cx="12" cy="5" r="2" />
        <circle cx="12" cy="12" r="2" />
        <circle cx="12" cy="19" r="2" />
    </svg>
);
const OfertingLists = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isScheduleModalVisible, setIsScheduleModalVisible] = useState(false);
    const [selectedTime, setSelectedTime] = useState(null);
    const [listToSchedule, setListToSchedule] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [form] = Form.useForm();
    const [listExists, setListExists] = useState(false);
    const [listId, setListId] = useState(null);
    const [lists, setLists] = useState([]);
    const [currentList, setCurrentList] = useState(null);
    const [index, setIndex] = useState(-1);
    const [editingListId, setEditingListId] = useState(null);
    const [editedName, setEditedName] = useState('');
    const [counts, setCounts] = useState({});
    const [isStopBiddingModalVisible, setIsStopBiddingModalVisible] = useState(false);
    const [listToStop, setListToStop] = useState(null);

    // Mobile detection using Ant Design Grid
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md; // md breakpoint is 768px
    const pathToKey = {
        '/liste-necesar': 'creeaza',
        '/gata-de-trimis': 'gata',
        '/liste-in-ofertare': 'ofertare',
        '/liste-ofertate': 'ofertate',
        '/procesare-manuala': 'procesareManuala',

        '/liste-arhivate': 'arhivate'
    };
    const selectedMenuKey = pathToKey[location.pathname];



    useEffect(() => {
        handleSearch('');

        listService.getLists('offering')
            .then(res => {
                if (res.data) {
                    setLists(res.data.necessity_lists);
                }
            })
            .catch(err => {
                console.error("Eroare la încărcarea listelor:", err);
            });
    }, []);

    useEffect(() => {

        listService.getCounts()
            .then(res => {
                if (res.data) {
                    setCounts(res.data.list_counts);

                }
            })
            .catch(err => {
                console.error("Eroare la încărcarea listelor:", err);
            });

    }, []);

    const handleSearch = (value) => {
        setSearchQuery(value);
        if (value.length > 0) {
            listService.searchList(value, 1, 'offering')
                .then(res => {
                    if (res.data?.necessity_lists) {
                        setSearchResults(res.data.necessity_lists);
                    } else {
                        setSearchResults([]);
                    }
                })
                .catch(err => {
                    console.error("Eroare la căutare:", err);
                    setSearchResults([]);
                });
        } else {
            setSearchResults([]);
        }
    };

    const isBiddingExpired = (record) => {
        const biddingEndTime = record?.bidding_end_time;
        if (!biddingEndTime) {
            return false;
        }

        return moment(biddingEndTime).isSameOrBefore(moment());
    };



    const handleListAction = (action, record) => {
        const canViewOffers = ListStatusGuard.canExtendBidding(record.status) || ListStatusGuard.canStopBidding(record.status);
        const canExtendBidding = ListStatusGuard.canExtendBidding(record.status) && !isBiddingExpired(record);
        const canStopBidding = ListStatusGuard.canStopBidding(record.status);

        switch (action) {
            case 'view':
                if (!canViewOffers) {
                    return;
                }
                navigate(`/liste-in-ofertare/vezi-oferte/${record.id}`);
                break;

            case 'schedule':
                if (!canExtendBidding) {
                    return;
                }
                setListToSchedule(record);
                setSelectedTime(null);
                setIsScheduleModalVisible(true);
                break;
            case 'send':
                console.log("Trimite lista:", record.id);
                break;
            case 'delete':
                if (!canStopBidding) {
                    return;
                }
                setListToStop(record);
                setIsStopBiddingModalVisible(true);
                break;
            default:
                break;
        }
    };

    // Helper function for rendering bidding stats (used in both desktop and mobile)
    const renderBiddingStats = (_, record) => {
        const { items_with_bids, total_items } = record.bidding_stats || {};
        return `${items_with_bids || 0} / ${total_items || 0}`;
    };

    // Helper function for rendering actions (used in both desktop and mobile)
    const renderActions = (_, record) => {
        const canViewOffers = ListStatusGuard.canExtendBidding(record.status) || ListStatusGuard.canStopBidding(record.status);
        const canExtendBidding = ListStatusGuard.canExtendBidding(record.status) && !isBiddingExpired(record);
        const canStopBidding = ListStatusGuard.canStopBidding(record.status);

        const menuItems = [
            {
                key: 'view',
                label: 'Vezi oferte',
                icon: <EyeOutlined />,
                disabled: !canViewOffers,
            },
            {
                key: 'schedule',
                label: 'Adaugă timp',
                icon: <ScheduleOutlined />,
                disabled: !canExtendBidding,
            },
            {
                key: 'delete',
                label: 'Opreste ofertarea',
                icon: <StopOutlined />,
                danger: true,
                disabled: !canStopBidding,
            },
        ];

        return (
            <Dropdown
                menu={{
                    items: menuItems,
                    onClick: ({ key }) => handleListAction(key, record)
                }}
                trigger={['click']}
                placement="bottomRight"
            >
                <Button type="text" className="list__mobile-card-actions-btn" style={{ padding: 0, border: 'none', background: 'transparent' }}>
                    <VerticalDotsIcon />
                </Button>
            </Dropdown>
        );
    };

    // Desktop columns (all columns)
    const listColumnsDesktop = [
        {
            title: 'Număr listă',
            dataIndex: 'id',
            key: 'id',
            width: 100,
        },
        {
            title: 'Nume',
            dataIndex: 'title',
            key: 'title'
        },
        {
            title: 'Timp rămas',
            dataIndex: 'bidding_end_time',
            key: 'bidding_end_time',
            width: 140,
            render: (value) => <Countdown targetDate={value} />,
        },
        {
            title: 'Produse ofertate',
            dataIndex: 'bidding_stats',
            key: 'bidding_stats',
            width: 140,
            render: renderBiddingStats,
        },
        {
            title: 'Acțiuni',
            key: 'actions',
            width: 100,
            render: renderActions,
        },
    ];

    // Mobile columns (only: Nr, Nume, Timp ramas, Ofertate, Opti)
    const listColumnsMobile = [
        {
            title: 'Nr',
            dataIndex: 'id',
            key: 'id',
            width: 50,
        },
        {
            title: 'Nume',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Timp ramas',
            dataIndex: 'bidding_end_time',
            key: 'bidding_end_time',
            width: 100,
            render: (value) => <Countdown targetDate={value} />,
        },
        {
            title: 'Ofertate',
            dataIndex: 'bidding_stats',
            key: 'bidding_stats',
            width: 100,
            render: renderBiddingStats,
        },
        {
            title: 'Opti',
            key: 'actions',
            width: 50,
            render: renderActions,
        },
    ];

    // Conditional columns based on screen size
    const listColumns = isMobile ? listColumnsMobile : listColumnsDesktop;

    // Mobile List Component (pseudotabel)
    const MobileList = () => {
        const dataSource = searchQuery.length > 0 ? searchResults : lists;

        if (dataSource.length === 0) {
            return (
                <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
                    Niciun produs găsit.
                </div>
            );
        }

        return (
            <div className="list__mobile-table-wrapper">
                <div className="list__mobile-table-header">
                    <div className="list__mobile-table-header-cell" style={{ width: '20px', flexShrink: 0 }}>
                        Nr.
                    </div>
                    <div className="list__mobile-table-header-cell list__mobile-table-header-name">
                        Nume
                    </div>
                    <div className="list__mobile-table-header-cell" style={{ width: '50px', flexShrink: 0 }}>
                        Timp ramas
                    </div>
                    <div className="list__mobile-table-header-cell" style={{ width: '50px', flexShrink: 0 }}>
                        Ofertate
                    </div>
                    <div className="list__mobile-table-header-cell list__mobile-table-header-actions" style={{ width: '20px', flexShrink: 0 }}>
                        Opti.
                    </div>
                </div>
                <div className="list__mobile-list">
                    {dataSource.map((row) => {
                        const canViewOffers = ListStatusGuard.canExtendBidding(row.status) || ListStatusGuard.canStopBidding(row.status);
                        const canExtendBidding = ListStatusGuard.canExtendBidding(row.status) && !isBiddingExpired(row);
                        const canStopBidding = ListStatusGuard.canStopBidding(row.status);
                        const menuItems = [
                            {
                                key: 'view',
                                label: 'Vezi oferte',
                                icon: <EyeOutlined />,
                                disabled: !canViewOffers,
                            },
                            {
                                key: 'schedule',
                                label: 'Adaugă timp',
                                icon: <ScheduleOutlined />,
                                disabled: !canExtendBidding,
                            },
                            {
                                key: 'delete',
                                label: 'Opreste ofertarea',
                                icon: <StopOutlined />,
                                danger: true,
                                disabled: !canStopBidding,
                            },
                        ];

                        return (
                            <div key={row.id} className="list__mobile-card">
                                <div className="list__mobile-card-cell" style={{ width: '20px', flexShrink: 0 }}>
                                    {String(row.id).padStart(2, '0')}
                                </div>
                                <div className="list__mobile-card-cell list__mobile-card-name" title={row.title}>
                                    {row.title}
                                </div>
                                <div className="list__mobile-card-cell" style={{ width: '50px', flexShrink: 0 }}>
                                    <Countdown targetDate={row.bidding_end_time} />
                                </div>
                                <div className="list__mobile-card-cell" style={{ width: '50px', flexShrink: 0 }}>
                                    {renderBiddingStats(null, row)}
                                </div>
                                <div className="list__mobile-card-cell list__mobile-card-actions" style={{ width: '20px', flexShrink: 0 }}>
                                    <Dropdown
                                        menu={{
                                            items: menuItems,
                                            onClick: ({ key }) => handleListAction(key, row)
                                        }}
                                        trigger={['click']}
                                        placement="bottomRight"
                                    >
                                        <Button
                                            type="text"
                                            className="list__mobile-card-actions-btn"
                                            style={{ padding: 0, border: 'none', background: 'transparent' }}
                                        >
                                            <VerticalDotsIcon />
                                        </Button>
                                    </Dropdown>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    const handleDeleteList = list => {
        console.log('aici')
        console.log(list)
        listService.deleteList(list.id)
            .then(() => {
                toast.success('Stergere reusita')
                setLists(prevLists => prevLists.filter(item => item.id !== list.id));
                setIsDeleteModalVisible(false)
            })
            .catch(error => {
                console.error('Eroare');
                setIsDeleteModalVisible(false);
            });
    };
    const showDeleteModal = (list) => {
        setCurrentList(list);

        setIsDeleteModalVisible(true);
    };

    const handleCancelDelete = () => {
        setIsDeleteModalVisible(false);
    };
    const handleStopBidding = (list) => {
        listService.stopBidingTime(list.id)
            .then(() => {
                toast.success('Ofertarea a fost oprită cu succes!');
                setLists(prev => prev.filter(item => item.id !== list.id));
            })
            .catch(() => {
                toast.error('Eroare la oprirea ofertării!');
            });
    };

    const confirmStopBidding = () => {
        if (!listToStop) {
            return;
        }

        handleStopBidding(listToStop);
        setIsStopBiddingModalVisible(false);
        setListToStop(null);
    };

    const handleScheduleTimeAdd = () => {
        if (!selectedTime || !listToSchedule) {
            toast.error("Selectează o durată!");
            return;
        }

        const addedMinutes = selectedTime === '30min' ? 30 : 60;
        const updatedEndTime = moment(listToSchedule.bidding_end_time).add(addedMinutes, 'minutes').toISOString();

        listService.addBidingTime(listToSchedule.id, addedMinutes)
            .then(() => {
                toast.success('Timp adăugat cu succes!');
                setLists(prev =>
                    prev.map(list =>
                        list.id === listToSchedule.id
                            ? { ...list, bidding_end_time: updatedEndTime }
                            : list
                    )
                );
            })
            .catch(() => {
                toast.error('Eroare la actualizarea timpului');
            })
            .finally(() => {
                setIsScheduleModalVisible(false);
                setSelectedTime(null);
            });
    };
    return (
        <div className='standard products list'>
            <Header />


            <div className='standard__container list'>
                <Menu />
                <div className='standard__wrapper'>
                    <div style={{ padding: 24, minHeight: 280 }}>
                        <h2 className='standard__page-title'>Liste in ofertare</h2>
                        <h4 className='standard__page-info'>
                            În acest meniu poți vedea listele aflate în ofertare deschisă și poți vizualiza sau modifica timpul disponibil pentru ofertare.
                        </h4>

                        <div className='list__search-box'>
                            <Search
                                className="list__search-input"
                                placeholder="Caută lista..."
                                onChange={(e) => handleSearch(e.target.value)}
                                value={searchQuery}
                                enterButton
                                allowClear
                            />

                        </div>
                        <div className='list__tabs-wrapper'>
                            <AntMenu
                                mode="horizontal"
                                selectedKeys={[selectedMenuKey]}
                                style={{ marginTop: 16 }}
                                onClick={(e) => {
                                    switch (e.key) {
                                        case 'creeaza':
                                            navigate('/liste-necesar');
                                            break;
                                        case 'gata':
                                            navigate('/gata-de-trimis');
                                            break;
                                        case 'ofertare':
                                            navigate('/liste-in-ofertare');
                                            break;
                                        case 'ofertate':
                                            navigate('/liste-ofertate');
                                            break;
                                        case 'procesareManuala':
                                            navigate('/procesare-manuala');
                                            break;
                                        case 'arhivate':
                                            navigate('/liste-arhivate');
                                            break;
                                        default:
                                            break;
                                    }
                                }}
                            >
                                <AntMenu.Item key="creeaza">Creează listă</AntMenu.Item>
                                <AntMenu.Item key="gata">
                                    Gata de trimis ({counts.ready_to_send || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="ofertare">
                                    Liste în ofertare ({counts.offering || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="ofertate">
                                    Liste ofertate ({counts.offered || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="procesareManuala">
                                    Procesare manuala ({counts.manual_processing || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="arhivate">
                                    Liste arhivate ({counts.archived || 0})
                                </AntMenu.Item>
                            </AntMenu>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>


                            {currentList && currentList.created_at && (
                                <div style={{ textAlign: 'right', marginLeft: 'auto' }}>
                                    <div><strong>Listă #{currentList.id}</strong></div>
                                    <div>Creată pe: {new Date(currentList.created_at).toLocaleDateString('ro-RO')}</div>
                                </div>
                            )}
                        </div>

                        <div className="list__table-wrapper">
                            <div className='list__table-content'>
                                {!isMobile ? (
                                    <Table
                                        dataSource={searchQuery ? searchResults : lists}
                                        columns={listColumnsDesktop}
                                        rowKey="id"
                                        pagination={false}
                                        scroll={{ x: true }}
                                    />
                                ) : (
                                    <MobileList />
                                )}
                            </div>
                        </div>


                    </div>
                </div>
            </div>

            <MobileBottomMenu />

            <Modal
                title="Confirmă ștergere"
                open={isDeleteModalVisible}
                onOk={() => handleDeleteList(currentList)}
                onCancel={handleCancelDelete}
                okText="Șterge"
                cancelText="Cancel"
            >
                <p>Sunteți sigur că doriți să ștergeți aceasta lista?</p>
            </Modal>
            <Modal
                title="Adaugă timp la ofertare"
                open={isScheduleModalVisible}
                onOk={handleScheduleTimeAdd}
                onCancel={() => {
                    setIsScheduleModalVisible(false);
                    setSelectedTime(null);
                }}
            >
                <Select
                    placeholder="Selectează durată"
                    style={{ width: '100%' }}
                    value={selectedTime}
                    onChange={value => setSelectedTime(value)}
                >
                    <Option value="30min">30 minute</Option>
                    <Option value="1h">1 oră</Option>
                </Select>
            </Modal>
            <Modal
                title="Confirmă oprirea ofertării"
                open={isStopBiddingModalVisible}
                okText="Oprește ofertarea"
                cancelText="Renunță"
                okButtonProps={{ danger: true }}
                onOk={confirmStopBidding}
                onCancel={() => {
                    setIsStopBiddingModalVisible(false);
                    setListToStop(null);
                }}
            >
                <p>
                    Sigur vrei să oprești ofertarea pentru lista
                    {listToStop ? ` #${listToStop.id}` : ''}?
                </p>
            </Modal>
        </div>
    );
};

export default OfertingLists;